
import React from "react";
import * as Hooks from "../../../../hooks";
import { Schemes, Utils } from "../../../../utils";
import * as ReactRouterDom from "react-router-dom";
import { BaseService, IMember, ITournamentEdition, TournamentService, TournamentStatus } from "../../../../services";
import { Button, Classname, DateHelper, Dropdown, FormControl, Messages, MessagesManageRef, NoseurObject, Popover, PopoverManageRef, ResizeSensor, Scheme, TextInput, Transition, useScreenDimension, useSubscription } from "@rivtn/noseur";
import { Link, NavLink } from "react-router-dom";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import Participants from "./sections/Participants";
import TournamentNotifications from "./sections/TournamentNotifications";
import { showTournamentPass } from "../../tournaments/your_tournament/shared/MatchCard";
import Snapper from "../../../shared/Snapper";
import StageFormatBracket from "./sections/StageFormatBracket";
import MatchFixtures from "./sections/MatchFixtures";
import Finance from "./sections/Finance";
import TournamentTransactions from "./sections/TournamentTransactions";
import TournamentAnalytics from "./sections/earnings/TournamentAnalytics";
import TournamentEarningsAnalytics from "./sections/earnings/TournamentEarningsAnalytics";
import TournamentParticipantsAnalytics from "./sections/earnings/TournamentParticipantsAnalytics";
import TournamentMatchesAnalytics from "./sections/earnings/TournamentMatchesAnalytics";
import TournamentPrizePoolAnalytics from "./sections/earnings/TournamentPrizePoolAnalytics";
import ResultAndPrizeDistribution from "./sections/ResultAndPrizeDistribution";
import HistoricPrizePool from "./sections/result_and_prize_pool/HistoricPrizePool";
import Scoring from "./sections/Scoring";
import TournamentSettings from "./sections/settings/TournamentSettings";
import { ConfirmDialog } from "../../../shared/ConfirmDialog";

export interface ManageTournamentProps {
    profile: IMember;
}

function ManageTournament(props: ManageTournamentProps) {

    const { profile } = props;
    const { width } = useScreenDimension();
    const navigate = ReactRouterDom.useNavigate();
    const [themeMode, setThemeMode] = Hooks.useThemeMode();
    const labels = i18nManager.Labels.host.manage_tournament;
    const tournamentService = TournamentService.getInstance();
    const popoverControlEls = React.useRef<NoseurObject<any>>({});
    const dataComponentState = React.useState<React.ReactElement>();
    const messagesManageRef = React.useRef<MessagesManageRef>(null);
    const mobileMenuPopOverManageRef = React.useRef<PopoverManageRef>(null);
    const [snapTournament, setSnapTournament] = React.useState<() => void>();
    let { id: hostPublicId = "", tournamentId } = ReactRouterDom.useParams();
    const collapseSidebar = useSubscription("OMNEHOST.PAGE.COLLAPSE_SIDEBAR");
    const [tournamentEdition, setTournamentEdition] = React.useState<ITournamentEdition>();
    const [unReads, setUnReads] = React.useState<{ messages: number; notifications: number }>();
    const [tournamentEditions, setTournamentEditions] = React.useState<ITournamentEdition[]>([]);
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const tournamentLink = Utils.buildPublicUrl("TOURNAMENT", tournamentEdition?.tournament?.public_id!);
    const [messages, setMessages] = React.useState<{ msg: string; action: { lo: string; la: string; }; }[]>();
    /*useSubscription("OMNEHOST.MANAGE.TOURNAMENT.READ.NOTIFS", (count: number) => {
        setUnReads({ messages: (unReads?.messages ?? 0), notifications: (count === 0 ? 0 : (unReads?.notifications ?? 0) + count) });
    });*/

    React.useEffect(() => {
        fetchInformations();
        setTimeout(() => collapseSidebar(true), 100);

        return () => {
            collapseSidebar(Utils.getSetting("csb", false));
        };
    }, []);

    React.useEffect(() => {
        if (!messages) return;
        messagesManageRef.current?.show(messages.map((message) => ({
            fill: true,
            sticky: true,
            transition: Transition.ZOOM_IN,
            content: <div className="verify-profile" style={{ margin: "0px 10px" }}>
                <span>{message.msg} <a href={message.action.lo}>{message.action.la}</a></span>
            </div>,
        })));
    }, [messages]);

    React.useEffect(fetchTournamentEdition, [searchParams.get("edition")]);

    if (!tournamentEdition) {
        return Elements.LOADING_STATE;
    }

    return (<div className="manage-tour">
        <div className="mt-header">
            <div className="mt-tour-info" style={{ margin: "0px 15px", flex: 1 }}>
                <ResizeSensor maxDimension={{ width: 800 }}>
                    <Button outlined iconOnly borderless leftIcon="fa fa-bars" scheme={Schemes.OMNEHOST} style={{ marginRight: 10, marginTop: 20 }} ref={(el) => { popoverControlEls.current["mobile-menu"] = el; }} onClick={(e: any) => {
                        mobileMenuPopOverManageRef.current?.toggle(e, popoverControlEls.current["mobile-menu"]);
                    }} />
                </ResizeSensor>
                {(width > 800) && (<ReactRouterDom.Link style={{ fontWeight: "normal" }} to={tournamentLink} target="_blank" className="mt-tour-info">
                    <img src={tournamentEdition.tournament.extra_data?.logo_url ? tournamentEdition.tournament.extra_data?.logo_url : tournamentEdition.logo_url} alt={tournamentEdition.name} />
                    <span className="n">{tournamentEdition.tournament.name ?? tournamentEdition.name}</span>
                    <i className="fa fa-external-link" />
                </ReactRouterDom.Link>)}
                <Dropdown fill scheme={Schemes.OMNEHOST} dontMatchTargetSize formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.top_bar.edition, style: { marginTop: (width > 800 ? -5 : 5), maxWidth: 250, marginLeft: (width > 800 ? 10 : 0) } }}
                    options={tournamentEditions} selectedOptionIndex={tournamentEditions.findIndex((f) => f.external_id === tournamentEdition.external_id)}
                    popoverHeaderTemplate={() => (<div style={{ margin: 10, display: "flex", flexDirection: "column", paddingBottom: 15, borderBottom: "1px solid #E3E3E3" }}>
                        <FormControl isFieldset fill label={labels.top_bar.search}>
                            <TextInput fill onInput={({ }: any) => {

                            }} />
                        </FormControl>
                        <span className="link" style={{ marginTop: 10, marginLeft: 5 }} onClick={createEdition}>{labels.top_bar.create_edition}</span>
                    </div>)} optionTemplate={(option: ITournamentEdition) => (<div style={{ display: "flex", flexDirection: "row" }}>
                        <img alt={option.name} src={option.logo_url} style={{ width: 40, height: 40, marginRight: 10, borderRadius: "100%" }} />
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span style={{ fontWeight: 500, marginBottom: 2 }}>{option.name}</span>
                            <span style={{ fontSize: 14 }}>{labels.top_bar.date} {Utils.formatToFineDate(option.dates.registration_start_date ?? DateHelper.addDays(new Date(), 100), true)}</span>
                        </div>
                    </div>)} optionMap={{ icon: "logo_url", label: "name" }} onSelectOption={(o) => {
                        Utils.updateSearchParams("edition", o.external_id, setSearchParams);
                    }} />
                {buildStatusLabel(tournamentEdition.status)}
            </div>
            <div className="mt-links">
                <ReactRouterDom.Link target="_blank" to={Utils.buildPublicUrl("TOURNAMENT", tournamentEdition.tournament.public_id, "?edition=" + tournamentEdition.external_id)} >{labels.top_bar.visit}</ReactRouterDom.Link>
                <ReactRouterDom.Link to={`/hosts/${hostPublicId}/create-tournament/${tournamentEdition.external_id}?section=DETAILS`} >{labels.top_bar.change_details}</ReactRouterDom.Link>
                {(width > 800) && (<>
                    <ReactRouterDom.Link to={`/hosts/${hostPublicId}/create-tournament/${tournamentEdition.external_id}?section=MEDIA`} >{labels.top_bar.update_media}</ReactRouterDom.Link>
                    <ReactRouterDom.Link to={`/hosts/${hostPublicId}/create-tournament/${tournamentEdition.external_id}?section=DATES`} >{labels.top_bar.change_dates}</ReactRouterDom.Link>
                </>)}
                <ReactRouterDom.Link to={`/hosts/${hostPublicId}/create-tournament/${tournamentEdition.external_id}`} >{labels.top_bar.edit_in_wizard_mode}</ReactRouterDom.Link>
                <Snapper header={labels.top_bar.tour_snap} template={[{ p: "tour_name", v: tournamentEdition.name }]} actionReference={setSnapTournament} />
            </div>
        </div>
        <div className="mt-compound">
            {renderSidebar(tournamentEdition)}
            <div className="mt-main-container" style={width < 800 && !!dataComponentState[0] ? { flex: 0.2 } : undefined}>
                <Messages manageRef={messagesManageRef} positionProps={{
                    relative: true,
                    className: "full-length-messages",
                    style: {
                        top: 0,
                        right: 0,
                    },
                }} />
                <div className={"mt-content"}>
                    <ReactRouterDom.Routes>
                        <ReactRouterDom.Route path="/finance" element={<Finance tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/analytics" element={<TournamentAnalytics tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/notifications" element={<TournamentNotifications tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/finance/transactions" element={<TournamentTransactions tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/analytics/matches" element={<TournamentMatchesAnalytics tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/settings" element={<TournamentSettings profile={profile} tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/analytics/prize-pool" element={<TournamentPrizePoolAnalytics tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/scoring" element={<Scoring tournamentEdition={tournamentEdition} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/analytics/participants" element={<TournamentParticipantsAnalytics tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/analytics/earnings" element={<TournamentEarningsAnalytics profile={profile} tournamentEdition={tournamentEdition} />} />
                        <ReactRouterDom.Route path="/match-fixtures" element={<MatchFixtures tournamentEdition={tournamentEdition} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/stage-format-bracket" element={<StageFormatBracket tournamentEdition={tournamentEdition} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/analytics/matches/all" element={<MatchFixtures historic tournamentEdition={tournamentEdition} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/result-prize-distro" element={<ResultAndPrizeDistribution tournamentEdition={tournamentEdition} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/result-prize-distro/historic" element={<HistoricPrizePool tournamentEdition={tournamentEdition} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/participants" element={<Participants tournamentEdition={tournamentEdition} snapTournament={snapTournament} dataComponentState={dataComponentState} />} />
                        <ReactRouterDom.Route path="/analytics/participants/all" element={<Participants historic tournamentEdition={tournamentEdition} snapTournament={snapTournament} dataComponentState={dataComponentState} />} />
                    </ReactRouterDom.Routes>
                </div>
            </div>
            {(dataComponentState[0]) && (<div className={Classname.build("mt-data-container", Transition.SLIDE_RIGHT_TO_LEFT)}>
                {dataComponentState[0]}
            </div>)}
        </div>

        <Popover manageRef={mobileMenuPopOverManageRef} className={Classname.build("noseur-popover-b np-b-min manage-tour", themeMode)} style={{ marginTop: 60, minWidth: 0, width: "100dvw !important", height: "100dvh !important", left: 0, minHeight: "100dvh !important" }}>
            <div className="mt-compound">
                {renderSidebar(tournamentEdition, () => {
                    mobileMenuPopOverManageRef?.current?.hide();
                })}
            </div>
        </Popover>
    </div>);

    function renderSidebar(tournamentEdition: ITournamentEdition, onItemClicked?: () => void) {
        return (<div className="mt-sidebar" onClick={onItemClicked}>
            <div className="mt-sidebar-links">
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/participants`} >
                    <i className="fa fa-users icon" />
                    <span>{labels.side_bar.participants}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/stage-format-bracket`} >
                    <i className="fa fa-step-forward icon" />
                    <span>{labels.side_bar.stage_format_bracket}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/match-fixtures`} >
                    <i className="fa fa-soccer-ball icon" />
                    <span>{labels.side_bar.match_fixtures}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/scoring`} >
                    <i className="fa fa-quidditch icon" />
                    <span>{labels.side_bar.scoring}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/result-prize-distro`} >
                    <i className="fa fa-trophy icon" />
                    <span>{labels.side_bar.result_prize_distro}</span>
                </ReactRouterDom.NavLink>
            </div>
            <div className="mt-sidebar-links">
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/finance`} >
                    <i className="fa fa-coins icon" />
                    <span>{labels.side_bar.finance}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`./chatroom`} >
                    <div className="icon">
                        <i className="far fa-comment" />
                        {((unReads?.messages ?? 0) > 0) && (<span className="noseur-badge noseur-danger noseur-no-border" style={{ marginLeft: -10 }}>{unReads?.messages}</span>)}
                    </div>
                    <span>{labels.side_bar.chat_room}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/notifications`} >
                    <div className="icon">
                        <i className="far fa-bell" />
                        {((unReads?.notifications ?? 0) > 0) && (<span className="noseur-badge noseur-danger noseur-no-border" style={{ marginLeft: -10 }}>{unReads?.notifications}</span>)}
                    </div>
                    <span>{labels.side_bar.notifications}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/analytics`} >
                    <i className="fa fa-bar-chart icon" />
                    <span>{labels.side_bar.analytics}</span>
                </ReactRouterDom.NavLink>
                <ReactRouterDom.NavLink to={`/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament.external_id}/settings`} >
                    <i className="fa fa-gear icon" />
                    <span>{labels.side_bar.settings}</span>
                </ReactRouterDom.NavLink>
            </div>
        </div>);
    }

    function fetchInformations() {
        const edition = searchParams.get("edition");
        if (!tournamentId && !edition) return;
        tournamentService.queryTournamentEditions({
            limit: 10,
            sort: "id,DESC",
            __member_id__: profile.external_id,
            "tournament.external_id": tournamentId
        }).then(({ content }) => {
            setTournamentEditions(content);
        }).catch(BaseService.reportError);
    }

    function fetchTournamentEdition() {
        setTournamentEdition(undefined);
        const edition = searchParams.get("edition");
        if (!tournamentId && !edition) return;
        if (edition) {
            tournamentService.getSingleTournamentEdition(edition!).then(({ sanitized }) => {
                setTournamentEdition(sanitized);
                reportPendingActions(sanitized);
                setUnReads(sanitized?.un_reads);
            }).catch(BaseService.reportError);
        } else {
            tournamentService.getSingleTournament(tournamentId!).then(({ sanitized }) => {
                const tournamentEdition = sanitized.current_edition;
                delete sanitized.current_edition;
                tournamentEdition.tournament = sanitized;
                setTournamentEdition(tournamentEdition);
                reportPendingActions(tournamentEdition);
                setUnReads(tournamentEdition?.un_reads);
            }).catch(BaseService.reportError);
        }
    }

    function reportPendingActions(sanitized: ITournamentEdition) {
        const messages: any[] = [];
        if (!(sanitized.program_id || sanitized.program)) {
            messages.push({ msg: labels.messages.no_program, action: { la: labels.messages.add_program, lo: `/hosts/${hostPublicId}/create-tournament/${sanitized.external_id}?section=PROGRAM_AND_PARTICIPANT` } });
        }
        if (!sanitized.logo_url) {
            messages.push({ msg: labels.messages.no_logo, action: { la: labels.messages.update_media, lo: `/hosts/${hostPublicId}/create-tournament/${sanitized.external_id}?section=MEDIA` } });
        }
        if (!sanitized.banner_url) {
            messages.push({ msg: labels.messages.no_banner, action: { la: labels.messages.update_media, lo: `/hosts/${hostPublicId}/create-tournament/${sanitized.external_id}?section=MEDIA` } });
        }
        setMessages(messages);
    }

    function buildStatusLabel(status: TournamentStatus) {
        const color = {
            [TournamentStatus.ENDED]: "#49C564",
            [TournamentStatus.DRAFT]: "#0D0D0D",
            [TournamentStatus.ONGOING]: "#D55C5C",
            [TournamentStatus.UPCOMING]: "#D55C5C",
            [TournamentStatus.REGISTERED]: "#D55C5C",
        }[status];
        return (<span style={{ fontWeight: "bold", color, marginLeft: 20, marginTop: (width > 800 ? 0 : 20) }}>{Utils.toSaneSentenceFormat(status)}</span>);
    }

    function createEdition() {
        if (!tournamentId) return;
        tournamentService.validateCanCreateNewTournamentEdition(tournamentId).then(({ sanitized }) => {
            navigate(`/hosts/${hostPublicId}/create-tournament`);
        }).catch(({ errorMessage }: any) => {
            const dialogLabels = labels.dialog.create_edition_failed;

            ConfirmDialog({
                dismissibleModal: true,
                title: dialogLabels.title,
                confirmLabel: i18nManager.Labels.common.close,
                desc: dialogLabels.desc.replace("${message}", errorMessage)
            }).show();
        });
    }

}

export default ManageTournament;

